import { useEffect, useState } from 'react';

import EmailGenerator from './EmailGenerator';
import { clearSessionTokenFromHash, readSession } from './session';

function App() {
  const [session] = useState(() => readSession());

  useEffect(() => {
    if (session?.token) {
      clearSessionTokenFromHash();
    }
  }, [session]);

  if (!session) {
    return (
      <div style={{ padding: 24, fontFamily: 'Inter, system-ui, sans-serif' }}>
        <h1>Email Generator</h1>
        <p>Missing token fragment. Open this page from the Relo admin panel.</p>
      </div>
    );
  }

  return <EmailGenerator token={session.token} />;
}

export default App;
